import JobQuiz from './JobQuiz';
import JobQuizResult from './JobQuizResult';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.js-form-job');
  if (form) new JobQuiz(form);

  if (document.querySelector('.js-quiz-result')) new JobQuizResult();
});
